import { AbsShare } from "../AbsShare";
import { ShareLayer } from "../ShareLayer";
import { ShareNavigator } from "../ShareNavigator";
import { BtnShareTrigger } from "./BtnShareTrigger";


// 레이어 포지션 잡기
export class BtnShareTriggerWithShareLayer {
    #X_DistanceFromBtnToLayer: number = 0;
    #Y_DistanceFromBtnToLayer: number = 0;

    constructor( private ElWrap: HTMLElement, private ElTriggerBtn: HTMLButtonElement, staticDistanceFromBtnToLayer: [number, number]){
        // 2) 레이어 위치 옵션이 있으면 레이어는 공유하기 버튼 기준으로 일정 거리에 위치한다.
        this.#initSetPositionElWrap(staticDistanceFromBtnToLayer);
    }

    // 포지션 세팅
    #initSetPositionElWrap(position: [number, number]){
        this.#X_DistanceFromBtnToLayer = position[0];
        this.#Y_DistanceFromBtnToLayer = position[1];

        // 초기 '레이어 포지션' 잡기
        this.#setPositionElWrap();
        // 리사이즈 할때마다 '레이어 포지션' 잡기
        this.#addEventWindowResize();
    }

    // '레이어 포지션' 잡기
    #setPositionElWrap = () => {
        const btnBottom = this.#triggerBtnBoundingClientRect.bottom;
        const btnRight = this.#triggerBtnBoundingClientRect.left;

        console.log(btnBottom, btnRight)

        this.ElWrap.style.left = btnRight + this.#X_DistanceFromBtnToLayer + 'px';
        this.ElWrap.style.top = btnBottom + this.#Y_DistanceFromBtnToLayer + 'px';
        this.ElWrap.style.transform = 'unset';
    }

    // 리사이즈
    #addEventWindowResize(){
        window.addEventListener('resize', this.#setPositionElWrap);
    }

    remove(){
        // 리사이즈 이벤트 제거
        window.removeEventListener('resize', this.#setPositionElWrap);
    }

    // 트리거 버튼 outline 위치
    get #triggerBtnBoundingClientRect(){
        return this.ElTriggerBtn.getBoundingClientRect();
    }

    static canUse(shareInstance: AbsShare, btnShareTriggerOption?: [number, number]): btnShareTriggerOption is [number, number]{
        return btnShareTriggerOption?.length && true || false;
    }
}
